import { InjectionToken } from '@angular/core';
import { CountryPhoneConfig } from './phone-number.models';

export const COUNTRY_WITH_DIAL_CODE_STORAGE_PREFIX = 'phone-number';

export const COUNTRY_WITH_DIAL_CODE_STORAGE_KEY = 'countries';

export const COUNTRIES_URL = new InjectionToken<string>('');

export const DEFAULT_PHONE_CONFIG: CountryPhoneConfig = {
  dialCode: '',
  minDigits: 8,
  maxDigits: 15
};
